module.exports = __webpack_public_path__ + "static/media/SaveError.cb9acc31.svg";